import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

async function addToFavorites(userId: string, productId: string): Promise<void> {
  const favDocRef = doc(db, "favorites", userId);

  try {
    const docSnap = await getDoc(favDocRef);

    if (docSnap.exists()) {
      const favorites = docSnap.data();

      if (favorites[productId]) {
        const updatedFavorites = { ...favorites };
        delete updatedFavorites[productId];

        if (Object.keys(updatedFavorites).length > 0) {
          await setDoc(favDocRef, updatedFavorites);
        } else {
          await setDoc(favDocRef, {});
        }
      } else {
        await updateDoc(favDocRef, {
          [productId]: true,
        });
      }
    } else {
      await setDoc(favDocRef, {
        [productId]: true,
      });
    }
  } catch (error) {
    console.error("Error toggling favorite:", error);
    throw error;
  }
}

export default addToFavorites;
